<template>
  <div class="my_advice">
    <div class="advicehea">我的咨询</div>
    <div class="consuont">
      <div class="listhea flex_end">
        <el-select v-model="value" placeholder="请选择" class="selec">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="coslist">
        <div class="cositem" v-for="item in 2" :key="item">
          <div class="cszxzw">
            <div class="ckgd center" v-if="false">
              <span
                >查看回复
                <svg-icon class="svgic flip90" icon-class="jt_right" />
              </span>
            </div>
            <div class="wtbt">请问老公婚后出轨，想离婚，财产怎么分？</div>
            <div class="wtdes">
              请问老公婚后出轨，想离婚，财产怎么分？请问老公婚后出轨，想离婚，财产怎么分？
            </div>
            <div class="wtla flex_start">
              <div class="wttime">2021.04.19 17:55 提交</div>
              <div class="wttag"><span>婚姻家庭</span></div>
            </div>
          </div>
          <div class="cslawhdlist"  v-if="false">
            <div class="cslawhditem" v-for="(i, j) in 2" :key="j">
              <div class="lawinfo flex_start">
                <div class="lscover">
                  <img src="~assets/zuimindetail/rt_sample.png" alt="" />
                </div>
                <div class="lsname">里斯律师</div>
                <div class="lshftime">2021.04.19 17:57回复</div>
                <div class="lscontact">律师电话：<span>17355183714</span></div>
              </div>
              <div class="lawanswer">
                <i class="el-icon-caret-top lasticon"></i>
                有证据证明对方是过错方的，那么分割财产是过错方可以适当少分
              </div>
              <div class="zwplq" v-if="false">
                <div class="zwplitem flex_start">
                  <div class="hfrr">用户回复</div>
                  <div class="hfnr">好的谢谢你</div>
                </div>
              </div>
              <div class="czbtn mt10 flex_end">
                <div class="btn zwlaw">追问律师</div>
                <div class="btn cnda">采纳答案</div>
                <div class="btn plser" v-if="false">评价服务</div>
              </div>
              <div class="zwintq"  v-if="false">
                <textarea
                  class="zwinput"
                  placeholder="问题没有问清楚？输入您的问题继续询问律师"
                />
                <div class="zwsubmit">提交</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wwzwbtn">问完又有新疑问？<span>再问一条</span></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "全部时间",
        },
        {
          value: "选项2",
          label: "一月内",
        },
        {
          value: "选项3",
          label: "一年内",
        },
      ],
      value: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.my_advice {
  box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.11);
  .advicehea {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 30px;
    background: #f4f4f4;
    font-size: 20px;
    color: #333333;
  }
  .consuont {
    padding: 26px;
    .listhea {
      .selec {
        width: 150px;
      }
    }
    .coslist {
      .cositem {
        margin-top: 25px;
        border: 1px solid #cccccc;
        .cszxzw {
          padding: 22px 20px;
          position: relative;
          .wtbt {
            width: 700px;
            font-size: 18px;
            color: #333333;
          }
          .wtdes {
            margin-top: 15px;
            font-size: 14px;
            color: #999999;
            width: 700px;
          }
          .wtla {
            margin-top: 15px;
            font-size: 12px;
            color: #999999;
            .wttag {
              margin-left: 50px;
            }
          }
          .ckgd {
            position: absolute;
            top: 0;
            right: 32px;
            height: 100%;
            font-size: 16px;
            color: #999999;
            span {
              cursor: pointer;
            }
            .svgic {
              margin-left: 5px;
            }
          }
        }
        .cslawhdlist {
          padding: 0 20px;
          border-top: 1px solid #cccccc;
          .cslawhditem {
            border-bottom: 1px #eee solid;
            padding: 30px 0;
            .lawinfo {
              .lscover {
                margin-right: 20px;
                img {
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                }
              }
              .lsname {
                font-size: 14px;
                color: #333333;
                margin-right: 20px;
              }
              .lshftime {
                font-size: 14px;
                color: #bbbbbb;
                margin-right: 22px;
              }
              .lscontact {
                font-size: 14px;
                color: #bbbbbb;
                span {
                  color: #f52f2f;
                }
              }
            }
            .lawanswer {
              margin-top: 10px;
              padding: 14px 20px;
              background: #f4f4f4;
              border-radius: 3px;
              font-size: 14px;
              color: #666666;
              position: relative;
              .lasticon {
                position: absolute;
                top: -24px;
                left: 60px;
                color: #f4f4f4;
                font-size: 40px;
              }
            }
            .zwplq {
              margin-top: 10px;
              .zwplitem {
                margin-top: 10px;
              }
              .hfrr {
                align-self: flex-start;
                padding: 2px 6px;
                border: 1px solid #bbbbbb;
                border-radius: 3px;
                font-size: 14px;
                color: #666666;
                margin-right: 20px;
              }
              .hfnr {
                width: 700px;
                font-size: 14px;
                color: #666666;
              }
            }
            .czbtn {
              .btn {
                width: 78px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                border-radius: 3px;
                font-size: 14px;
                margin-left: 30px;
                cursor: pointer;
                &.zwlaw {
                  background: #0057ff;
                  color: #ffffff;
                }
                &.cnda {
                  background: #4886ff;
                  color: #ffffff;
                }
                &.plser {
                  color: #ffffff;
                  background: #f3ac00;
                }
              }
            }
            .zwintq {
              .zwinput {
                width: 100%;
                min-height: 96px;
                padding: 14px 22px;
                background: #f4f4f4;
                margin: 20px 0 10px;
                border: none;
                outline: none;
              }
              .zwsubmit {
                width: 78px;
                height: 30px;
                background: #538eff;
                border-radius: 3px;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
                line-height: 30px;
                cursor: pointer;
              }
            }
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
    .wwzwbtn {
      width: 280px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      margin: 50px auto 0;
      background: #f4f4f4;
      border-radius: 18px;
      span {
        color: #0057ff;
        cursor: pointer;
      }
    }
  }
}
</style>